import { CenteredScreen } from '../../components/Screen';
import { APP_VERSION } from '../../version';
import { isAndroid } from '../../lib/platform';

/** Blocking update gate (feature #10). No way past until the app is updated. */
export function ForceUpdateScreen({ minVersion }: { minVersion: string }): JSX.Element {
  return (
    <CenteredScreen title="Update required" subtitle="A newer version is required to continue.">
      <p className="text-sm text-slate-600">
        You are on version <span className="font-semibold">{APP_VERSION}</span>. Version{' '}
        <span className="font-semibold">{minVersion}</span> or later is required.
      </p>
      {isAndroid ? (
        <a
          className="btn-primary mt-5 w-full"
          href="https://play.google.com/store/apps/details?id=com.mitang.mop"
        >
          Update now
        </a>
      ) : (
        <button type="button" className="btn-primary mt-5 w-full" onClick={() => location.reload()}>
          Reload
        </button>
      )}
    </CenteredScreen>
  );
}
